import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import ProfileBackedCampaignDetail from '../pages/ProfileBackedCampaignDetail.vue';
import ShippingModal from '../components/ShippingModal.vue';
import NavPanel from '../components/NavPanel.vue';

class ProfileBackedCampaignDetailComponent {
  constructor({ container }) {
    this.app = null;
    this.container = container;
  }

  init() {
    this.app = createApp(ProfileBackedCampaignDetail);

    // Register global components
    this.app.component('shipping-modal', ShippingModal);
    this.app.component('nav-panel', NavPanel);

    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    // Mount the Vue app to the specified container
    this.app.mount(this.container);
  }
}

export default ProfileBackedCampaignDetailComponent;